//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { Mixins } from '@theme/mixins';
import { ITrackableComponent, withTracking } from '@utils/withTracking';

/**
 * The StatBubbleSheet atom renders a background sheet for a StatBubble container.
 */

export const StatBubbleSheet = ({
  children,
  className,
  trackingId,
}: React.PropsWithChildren<
  React.HTMLAttributes<HTMLDivElement> & ITrackableComponent
>) => {
  return (
    <Sheet className={className} trackingId={trackingId}>
      {children}
    </Sheet>
  );
};

const Sheet = withTracking(
  styled.div(
    ({ theme }) => `
  ${Mixins.Sheet.Low}
  display: flex;
  flex-direction: column;
  padding: ${theme.spacings[3]};
`,
  ),
);

export default StatBubbleSheet;
